<template>
	<div class="container-fluid">
		<div class="card shadow-sm">
			<div class="card-body">
				<h6 class="mb-4">{{ $t('log_history.title') }}</h6>

				<!-- <div class="d-flex justify-content-between align-items-center mb-3">
					<div class="d-flex align-items-center">
						<input
							v-model="search"
							@input="debouncedSearch"
							type="text"
							class="form-control form-control-sm"
							placeholder="Search user or description"
							style="max-width: 260px"
						/>
					</div>
					<div class="d-flex align-items-center">
						<label class="mb-0 mr-2">Sort</label>
						<select v-model="sort" @change="loadLogs(1)" class="form-control form-control-sm">
							<option value="desc">Newest → Oldest</option>
							<option value="asc">Oldest → Newest</option>
						</select>
					</div>
				</div> -->

				<div class="table-responsive">
					<table class="table table-sm mb-3">
						<thead>
							<tr>
								<th>{{ $t('log_history.table_column_user') }}</th>
								<th>{{ $t('log_history.table_column_description') }}</th>
								<th class="text-right">{{ $t('log_history.table_column_day_time') }}</th>
							</tr>
						</thead>
						<tbody>
							<tr v-if="loading">
								<td colspan="3">Loading…</td>
							</tr>
							<tr v-else-if="error">
								<td colspan="3" class="text-danger">{{ error }}</td>
							</tr>
							<tr v-else-if="logHistory.data.length === 0">
								<td colspan="3">{{ $t('log_history.no_logs_found') }}</td>
							</tr>
							<tr v-for="log in logHistory.data" :key="log.id">
								<td>{{ log.causer?.name || '--' }}</td>
								<td>{{ log.description }}</td>
								<td class="text-right">{{ log.created_at ? formatDateTimeToSlash(log.created_at, true) : '--' }}</td>
							</tr>
						</tbody>
					</table>
				</div>
            
            <!-- pagination -->
            <div class="row">
               <div class="col-9">
                  <div class="float-left">
                     <pagination
                        v-model="logHistory.current_page"
                        :per-page="logHistory.per_page"
                        :records="logHistory.total"
                        @paginate="paginate"
                        :options="{texts: { count: '' }}"
                     />
                  </div>
               </div>
               <div class="col-3">
                  <div class="form-row">
                     <div class="col-6">
                        <label class="float-right">
                           <span class="align-middle">
                              {{ $t("account-page-visitor.show") }}
                           </span>
                        </label>
                     </div>
                     <div class="col-4">
                        <select
                           class="form-control"
                           v-model="logHistory.per_page"
                           required
                           @change="loadLogs(1)"
                        >
                           <option :value="10">10</option>
                           <option :value="25">25</option>
                           <option :value="50">50</option>
                           <option :value="100">100</option>
                           <option :value="250">250</option>
                           <option :value="500">500</option>
                        </select>
                     </div>
                  </div>
               </div>
            </div>
			</div>
		</div>
	</div>
</template>

<script>
import formatter from '@/mixins/formatters'

export default {
	name: 'LogHistory',
	mixins: [formatter],
	data() {
		return {
			logHistory: {
				data: [],
				current_page: 1,
				per_page: 10,
				total: 0
			},
			sort: 'desc',
			loading: false,
			error: '',
			search: '',
			timezone: null,
			debouncedSearch: () => {}
		}
	},
	// created() {
	// 	this.debouncedSearch = debounce(() => this.loadLogs(1), 400)
	// },
	mounted() {
		this.loadLogs()
	},
	methods: {
		async loadLogs(page) {
			this.loading = true
			this.error = ''
			try {
				const params = {
					page: page || this.logHistory.current_page,
					per_page: this.logHistory.per_page,
					// search: this.search || undefined,
					facility_id: window._app_facility.id || undefined
				}

				const res = await this.$lionheart.get('/v2/history-logs', { params })
				const payload = (res && res.data) || {}
            console.log('payload', payload);
				this.logHistory = {
					data: payload.data || [],
					current_page: payload.current_page || params.page || 1,
					per_page: payload.per_page || params.per_page || this.logHistory.per_page,
					total: payload.total || (payload.data ? payload.data.length : 0)
				}
			} catch (e) {
				console.error(e)
					this.error = 'Failed to load logs.'
			} finally {
				this.loading = false
			}
		},
		changePage(next) {
			if (next < 1 || next > this.totalPages) return
			this.loadLogs(next)
		},
		goBack() {
			if (this.$router) this.$router.back()
		},
      paginate(page) {
         this.loadLogs(page);
      },
	}
}
</script>

<style scoped>
.card-body {
	padding: 1.25rem 1.25rem 1rem 1.25rem;
}
</style>

